import type { FileRecord } from "@cohesive/api-client";
import { type Entity, getEntityData } from "@cohesive/ui-components";

/** External URL for "open in new tab" on canvas entity nodes. */
export function resolveCanvasEntityOpenTabUrl(entity: Entity): string | null {
  const d = getEntityData(entity) as Record<string, unknown>;

  if ("base" in entity && entity.base === "file") {
    return (d?.web_link as string) ?? null;
  }

  if ("base" in entity && entity.base === "file_record") {
    const rec = getEntityData(entity) as FileRecord;
    return rec?.origin_url ?? null;
  }

  return (
    (d?.web_link as string) ??
    (d?.html_link as string) ??
    (d?.granola_url as string) ??
    (d?.url as string) ??
    null
  );
}

export function openCanvasEntityTabUrl(url: string): void {
  const href =
    url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  window.open(href, "_blank", "noopener,noreferrer");
}
